<template>
    <div class="no-select d-flex flex-column flex-fill">
        <VuePerfectScrollbar
            class="d-flex flex-column flex-fill"
            style="height: calc(100dvh - 13.5rem);"
        >
            <div class="d-flex flex-column flex-md-row">
                <el-button
                    class="btn-ext-item d-flex col flex-column align-items-center justify-content-center flex-fill m-3"
                    style="height: 5rem"
                    @click=" action( $action.OPEN_POPUP_EXTRA_SERVICE_EXPAND_IMAGE_THRESHOLD ) "
                    type="primary"
                    plain >
                    <div class="d-flex flex-column">
                        <span class="extra-service-title">EXPAND THE MACHINE THRESHOLD</span >
                        <span
                            class="mt-2"
                            style="color: #757575; font-size: 0.8rem" >
                            <span>Current:</span>
                            <span class="ml-1 mr-1">{{ user.imageThreshold }}</span>
                            <span>machine</span>
                        </span>
                    </div>
                </el-button>
                <el-button
                    class="btn-ext-item d-flex col flex-column align-items-center justify-content-center flex-fill m-3"
                    style="height: 5rem"
                    @click=" action( $action.OPEN_POPUP_EXTRA_SERVICE_EXPAND_STORAGE_THRESHOLD ) "
                    type="primary"
                    plain >
                    <div class="d-flex flex-column">
                        <span class="extra-service-title" >INCREASE SIZE OF NETWORK DRIVE (Z:)</span >
                        <span class="mt-2" style="color: #757575; font-size: 0.8rem" >
                            <span>Current:</span>
                            <span class="ml-1 mr-1">{{ user.storageThreshold | formatSize }}</span>
                        </span>
                    </div>
                </el-button>
            </div>
            <div class="d-flex flex-column flex-md-row">
                <el-button
                    class="btn-ext-item d-flex col flex-column align-items-center justify-content-center flex-fill m-3"
                    style="height: 5rem"
                    @click="action($action.OPEN_POPUP_EXTRA_SERVICE_OPEN_PORT)"
                    type="primary"
                    plain >
                    <div class="d-flex flex-column">
                        <span class="extra-service-title" >OPEN PORT FOR MACHINE</span >
                    </div>
                </el-button>
                <el-button
                    class="btn-ext-item d-flex col flex-column align-items-center justify-content-center flex-fill m-3"
                    style="height: 5rem"
                    @click="action($action.OPEN_POPUP_EXTRA_SERVICE_NVLINK)"
                    type="primary"
                    plain >
                    <div class="d-flex flex-column">
                        <span class="extra-service-title">NVLINK</span>
                    </div>
                </el-button>
            </div>
            <div class="d-flex flex-column flex-md-row"> 
                <el-button
                    class="btn-ext-item d-flex col flex-column align-items-center justify-content-center flex-fill m-3"
                    style="height: 5rem"
                    @click=" action($action.OPEN_POPUP_EXTRA_SERVICE_HARDWARE_CHANGE) "
                    type="primary"
                    plain >
                    <div class="d-flex flex-column">
                        <span class="extra-service-title" >HARDWARE CUSTOMISE</span >
                    </div>
                </el-button>
                <el-button
                    class="btn-ext-item d-flex col flex-column align-items-center justify-content-center flex-fill m-3"
                    style="height: 5rem"
                    @click="action($action.OPEN_POPUP_EXTRA_SERVICE_LICENSE)"
                    type="primary"
                    plain >
                    <div class="d-flex flex-column">
                        <span class="extra-service-title" >LICENSE SOFTWARE</span >
                        <span class="mt-2" style="color: #757575; font-size: 0.8rem" >Octane</span >
                    </div>
                </el-button>
            </div> 
        </VuePerfectScrollbar>
    </div>
</template> 

<script>
// CSS

//Lib
import { mapState } from "vuex";

// Event, Dialog

// Api

// Constant

// Extend

// Components

export default {
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },

    methods: {
        action(type) {
            this.$emit("processingEvent", {
                event: "action",
                data: {
                    type: type,
                },
            });
        },
    },
};
</script>